/**
 *  LicenseThisTrackModal Component
 */

import { getLicenseString, setLicenseFromParams } from '../../../../redux/helpers/license';
import { getLicenseComponents } from '../../../../redux/selectors/staticData';
import { environment } from '../../../../relay';
import { LicensePriceFragment, LicensePriceQuery } from '../../../../relay/licensePrice';
import { RelayOperationBase } from '../../../../utils/relay';
import { canLicenseTrack } from '../../../../utils/track';
import './styles.scss';

import { withRouter, WithRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { createFragmentContainer, QueryRenderer } from 'react-relay';

import { TrackLicensingContext } from '../../../../contexts/trackLicensing';
import { ITrackLicensingContext } from '../../../../contexts/trackLicensing/types';
import AddToCartButton from '../../../atoms/buttons/AddToCartButton';
import PriceTag from '../../../atoms/text/PriceTag';
import { TrackCard } from '../../../organisms/modals/LicenseThisTrackModal/TrackCard';
import * as Modal from '../ModalBase';

interface IOwnStateProps {
  licenseString: string;
}

interface ITrackLicensingContextProps {
  licensingContext: ITrackLicensingContext;
}

interface IOwnProps {
  track: GQL.ITrackSearchResult;
}

type LicenseThisTrackModalProps =
  & IOwnProps
  & IOwnStateProps
  & ITrackLicensingContextProps
  & WithRouter;

interface IRelayVariables {
  trackSlug: string | undefined;
  usages: GQL.ILicenseUsageParamsInput[] | undefined;
}

const classes = new BEM('license-track-modal');

class LicenseThisTrackModalBase extends React.Component<LicenseThisTrackModalProps> {
  onModalClose: Modal.OnCloseModalHandler = () => {
    this.props.licensingContext.clearAll();
  }

  render() {
    const {
      licenseString,
      track,
    } = this.props;

    const price = track.price!;
    const isTrackLicenseValid = canLicenseTrack(track);

    return (
      <Modal.Component
        actions={(
          <>
            <Modal.CancelAction label="Continue Browsing" />
            {isTrackLicenseValid && (
              <Modal.Action
                Element={<AddToCartButton item={track} />}
                id="add-to-cart"
              />
            )}
          </>
        )}
        position={Modal.Position.Top}
        onClose={this.onModalClose}
        {...classes('', { invalid: !isTrackLicenseValid })}
      >
        <Modal.Content>
          {isTrackLicenseValid ? (
            <Modal.Title>
              Based on your selections, your license for the following track is&nbsp;
              <PriceTag amount={price} textColor="accent" />.
            </Modal.Title>
          ) : (
            <Modal.Title textColor="dangerous">
              We’re sorry, this track cannot be licensed in your chosen territory.
            </Modal.Title>
          )}
        </Modal.Content>
        <TrackCard licenseString={licenseString} track={track} {...classes('card') } />
      </Modal.Component>
    );
  }
}

const ConnectedLicenseThisTrackModal =
  connect<IOwnStateProps, {}, IOwnProps & ITrackLicensingContextProps, IStoreState>(
  (state, { licensingContext }) => {
    const components = getLicenseComponents(state);
    const usages = setLicenseFromParams(components, licensingContext.usages!);
    return {
      licenseString: getLicenseString(usages),
    };
  },
)(LicenseThisTrackModalBase);

const LicenseThisTrackModalRelay = createFragmentContainer(
  ConnectedLicenseThisTrackModal,
  LicensePriceFragment,
);

class LicenseThisTrackModalQueryRenderer extends React.Component<ITrackLicensingContextProps & WithRouter> {
  render() {
    const {
      licensingContext: {
        usages,
        trackSlug,
      },
    } = this.props;

    return (
      <QueryRenderer<RelayOperationBase<IRelayVariables, IOwnProps>>
        environment={environment}
        query={LicensePriceQuery}
        variables={{ trackSlug, usages }}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            return <LicenseThisTrackModalRelay {...props} {...this.props} />;
          }
          return null;
        }}
      />
    );
  }
}

const LicenseThisTrackModalWithTrackLicensingContext: React.SFC<WithRouter> = (props) => (
  <TrackLicensingContext.Consumer>
    {(ctx) => !!ctx.trackSlug && !!ctx.usages ? (
      <LicenseThisTrackModalQueryRenderer licensingContext={ctx} {...props} />
    ) : null}
  </TrackLicensingContext.Consumer>
);

export default withRouter<{}>(LicenseThisTrackModalWithTrackLicensingContext);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/LicenseThisTrackModal/index.tsx